"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.notificationCount = reselect_1.createSelector(moduleState, function (state) { return state.notificationCount; });
exports.notificationsSeen = reselect_1.createSelector(moduleState, function (state) { return state.notificationsSeen; });
// deprecated
exports.toastMessage = reselect_1.createSelector(moduleState, function (state) { return state.toastMessage; });
exports.filledToastMessage = reselect_1.createSelector(moduleState, function (state) { return state.filledToastMessage; });
exports.notificationMessage = reselect_1.createSelector(moduleState, function (state) { return state.notificationMessage; });
//# sourceMappingURL=selectors.js.map